// turno-arranque.js — señal "el Turno resolvió su diálogo de arranque" (#1686, fase 2a, F1 del revisor v2).
//
// Cubre R27 — .claude/specs/1686-checklist-uso-celular/
//
// Por qué existe: el pop-up "Lleva SmartDx a tu celular" (`components/pwa/AppCelularGate.jsx`) no puede
// adivinar con una ventana fija si el Turno va a abrir "¿Dónde trabajas hoy?" o el formulario de primera
// unidad. Ese effect de `views/Turno.js` espera a que carguen pestañas y lugares (`turno/lugares/` puede
// tardar ~12 s, ver `helpers/turno-lugares-gate.js`), y con 1 s de espera el pop-up salía primero y el
// selector lo reemplazaba en la misma carga (FocusTrap de MUI, #1534). Turno publica acá en qué terminó.
//
// Estados (de ESTA carga de la página, el módulo se reinicia con ella):
//   "pendiente"   → el Turno todavía no decidió, o nunca lo hará (un pedido colgado sin respuesta, otro
//                   dueño, intro o tutorial abiertos). El pop-up NO sale: falla hacia el lado seguro.
//                   Un error de red no deja la señal colgada: `lugaresLoaded` y `tabsLoaded` se ponen en el
//                   `finally` de `Turno.js` y el effect de unidad decide con lo que haya. Si se cae la
//                   carga de lugares sin censo pendiente publica "sin_dialogo" y el pop-up puede salir.
//                   Con pestañas caídas (`loadTabs`) y unidades sin caché de hoy abre el selector y
//                   publica "con_dialogo" (el pop-up no sale en esa carga); igual con lugares caídos y
//                   un censo pendiente. En ningún caso se apilan dos diálogos.
//   "sin_dialogo" → el effect de unidad terminó sin abrir selector, formulario ni censo.
//   "con_dialogo" → el effect abrió un diálogo. Pegajoso: el pop-up espera a la próxima carga.
// Sin React a propósito, para poder probarlo suelto (patrón de `turno-lugares-gate.js`).

export const EVENTO_ARRANQUE_TURNO = "smartdx:turno-arranque";

let estado = "pendiente";

export const leerArranqueTurno = () => estado;

// "con_dialogo" no retrocede nunca; "sin_dialogo" no pisa a "con_dialogo".
export const publicarArranqueTurno = (nuevo) => {
  if (nuevo !== "sin_dialogo" && nuevo !== "con_dialogo") return;
  if (estado === "con_dialogo" || estado === nuevo) return;
  estado = nuevo;
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EVENTO_ARRANQUE_TURNO, { detail: nuevo }));
  }
};

// Cada montaje del Turno decide su arranque de nuevo: un "sin_dialogo" de un montaje anterior de la misma
// carga no vale para el nuevo. "con_dialogo" se queda (pegajoso por carga).
export const nuevoArranqueTurno = () => {
  if (estado !== "sin_dialogo") return;
  estado = "pendiente";
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EVENTO_ARRANQUE_TURNO, { detail: estado }));
  }
};

// Solo para los tests.
export const reiniciarArranqueTurno = () => {
  estado = "pendiente";
};

export const suscribirArranqueTurno = (cb) => {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENTO_ARRANQUE_TURNO, cb);
  return () => window.removeEventListener(EVENTO_ARRANQUE_TURNO, cb);
};
